import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataResult } from '@progress/kendo-data-query';
import { AppConstant } from '../../../app.constant';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataToDelete } from 'src/app/_metronic/core/classes/core.class';

@Injectable({
  providedIn: 'root'
})
export class SectionService {
  apiUrl: string;
  kendoDataUrl: string;

  constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
    this.apiUrl = this.appConstant.getUrl();
  }

  manageSection(section) {
    return this.httpClient.post(`${this.apiUrl}/manageSection`, section).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  public getAllSectionKendo(): Observable<DataResult> {
    return this.httpClient.get(`${this.apiUrl}/getAllSection/`).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }
  async getAllSectionName() : Promise<any[]> {
    return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllSection/`).toPromise()).data;
  }
  getSectionById(Id) {
    return this.httpClient.get(`${this.apiUrl}/getSectionById/`+ Id).pipe(
        map((response: any) => {
            return response;
        })
    )
}
  getAll() {
    return new Promise((resolve, reject) => {
      this.httpClient.get(`${this.apiUrl}/getAllSection`).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  bulkInsert(SectionData) {
    return this.httpClient.post(`${this.apiUrl}/bulkImportSection`, SectionData).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  deleteMultipleSection(sectionIdNameList: Array<DataToDelete> = []) {
    return this.httpClient.post(`${this.apiUrl}/bulkDeleteSection/`, {
      DataToDelete: sectionIdNameList
    }).pipe(
      map((response: any) => {
        return response;
      }))
  }
}
